module.exports = __webpack_public_path__ + "media/images/icons/google-5733c87ee318149679ed77498fde959f.svg";